import CroustilleElement from "../lib/CroustilleElement";

class Slide extends CroustilleElement {
  constructor() {
    super("slide");
  }

  handleToggleClick(e) {
    if (this.node.classList.contains("open")) {
      this.close();
    } else {
      this.open();
    }
  }

  close() {
    if (this.node.classList.contains("open")) {
      this.node.classList.remove("open");
      document.body.classList.remove("slide-open");
    }
  }

  open() {
    if (!this.node.classList.contains("open")) {
      this.node.classList.add("open");

      document.body.classList.add("slide-open");
    }
  }

  handleKeyDown(e) {
    const evt = e || window.event;
    if (evt.keyCode === 27) {
      this.close();
    }
  }

  init() {
    this.toggle = this.child("toggle");
    this._handleToggleClick = this.handleToggleClick.bind(this);

    this.toggle &&
      this.toggle.addEventListener("click", this._handleToggleClick);
  }

  destroy() {
    this.toggle &&
      this.toggle.removeEventListener("click", this._handleToggleClick);
  }
}

export default Slide;
